import React from 'react'

export default function ApproveIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
            <path d="M7 0.5C3.13078 0.5 0 3.63111 0 7.5C0 11.3692 3.13111 14.5 7 14.5C10.8692 14.5 14 11.3689 14 7.5C14 3.63078 10.8689 0.5 7 0.5ZM7 13.5667C3.65485 13.5667 0.933324 10.8452 0.933324 7.5C0.933324 4.15482 3.65485 1.43332 7 1.43332C10.3452 1.43332 13.0667 4.15485 13.0667 7.5C13.0667 10.8452 10.3452 13.5667 7 13.5667Z" fill="black" />
            <path d="M10.7039 4.93356C10.5216 4.75131 10.2261 4.75131 10.0439 4.93356L5.88939 9.08809L3.9529 7.15163C3.77066 6.96938 3.47515 6.96938 3.29293 7.15163C3.11069 7.33388 3.11069 7.62935 3.29293 7.8116L5.55938 10.078C5.74159 10.2603 6.03718 10.2602 6.21934 10.078L10.7039 5.5935C10.8861 5.41125 10.8861 5.11581 10.7039 4.93356Z" fill="black" />
        </svg>
    )
}
